<template>
  <div class="col-md-2 menu pb-4" v-if="this.user != null">
    <div class="row">
      <div class="col-12">
        <div class="text-left plantel">{{this.user.plantel}}</div>
      </div>
    </div>

    <div class="row" v-if="this.user.user_level == 1">
      <div class="col-12 bgblanco rounded pt-3 pb-4">
        <ul>
          <li>
            <router-link to="/alumnos/calificaciones">
              <i class="fas fa-clipboard-list"></i>
              <span class="pl-2">Calificaciones</span>
            </router-link>
          </li>
          <li>
            <router-link to="/alumnos/calendario">
              <i class="fas fa-calendar-day"></i>
              <span class="pl-2">Calendario</span>
            </router-link>
          </li>
          <li>
            <router-link to="/alumnos/manuales">
              <i class="fas fa-book"></i>
              <span class="pl-2">Manuales</span>
            </router-link>
          </li>
          <li>
            <router-link to="/alumnos/reglamento">
              <i class="fas fa-book"></i>
              <span class="pl-2">Reglamento</span>
            </router-link>
          </li>
          <li>
            <router-link to="/alumnos/comunicate">
              <i class="fas fa-pencil-alt"></i>
              <span class="pl-2">Comunícate con el Rector</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="row" v-if="this.user.user_level == 2">
      <div class="col-12 bgblanco rounded pt-3 pb-2">
        <ul>
          <li>
            <router-link to="/egresados/estatus">
              <i class="fas fa-users"></i>
              <span class="pl-2">Estado de Titulación</span>
            </router-link>
          </li>
          <li>
            <router-link to="/egresados/calendario">
              <i class="fas fa-calendar-day"></i>
              <span class="pl-2">Calendario</span>
            </router-link>
          </li>
          <li>
            <router-link to="/egresados/manuales">
              <i class="fas fa-book"></i>
              <span class="pl-2">Manuales</span>
            </router-link>
          </li>
          <li>
            <router-link to="/egresados/reglamento">
              <i class="fas fa-book"></i>
              <span class="pl-2">Reglamento</span>
            </router-link>
          </li>
          <li>
            <router-link to="/egresados/actualizacion">
              <i class="fas fa-pencil-alt"></i>
              <span class="pl-2">Actualiza tus Datos</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="row pt-2 d-none d-md-flex text-center">
        <div class="col-10 offset-1">
          <img class="img-fluid" src="../assets/imgs/logo-egresados.png" alt="Vínculo Egresados">
        </div>
      </div>
    </div>

    <div class="row" v-if="this.user.user_level == 5">
      <div class="col-12 bgblanco rounded pt-3 pb-4">
        <ul>
          <li>
            <router-link to="/docentes/asignaturas">
              <i class="fas fa-pencil-alt"></i>
              <span class="pl-2">Asignaturas</span>
            </router-link>
          </li>
          <li>
            <router-link to="/docentes/calendario">
              <i class="fas fa-calendar-day"></i>
              <span class="pl-2">Calendario</span>
            </router-link>
          </li>
          <li>
            <router-link to="/docentes/manuales">
              <i class="fas fa-book"></i>
              <span class="pl-2">Manuales</span>
            </router-link>
          </li>
          <li>
            <router-link to="/docentes/reglamento">
              <i class="fas fa-book"></i>
              <span class="pl-2">Reglamento</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="row" v-if="this.user.user_level == 7">
      <div class="col-12 bgblanco rounded pt-3 pb-4">
        <ul>
          <li>
            <router-link to="/dashboard/alumnos">
              <i class="fas fa-user-friends"></i>
              <span class="pl-2">Alumnos</span>
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/docentes">
              <i class="fas fa-user-tie"></i>
              <span class="pl-2">Docentes</span>
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/programas">
              <i class="fas fa-book"></i>
              <span class="pl-2">Programas</span>
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/asignaturas">
              <i class="fas fa-pencil-alt"></i>
              <span class="pl-2">Asignaturas</span>
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/grupos">
              <i class="fas fa-users"></i>
              <span class="pl-2">Grupos</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="row pt-5 d-none d-md-flex text-center">
      <div class="col-12 pb-2">Inicio del periodo escolar</div>
      <div class="col-12 pb-2">
        <span class="bold">{{this.inicio_periodo_escolar}}</span>
      </div>
      <div class="col-12 pb-2">Fin del periodo escolar</div>
      <div class="col-12 pb-2">
        <span class="bold">{{this.fin_periodo_escolar}}</span>
      </div>
    </div>

    <div class="row pt-5 d-none d-md-flex btns">
      <div class="col-6 pb-2">
        <a href="http://app.vlex.com/#account/login" target="_blank">
          <img
            class="img-fluid w-75 pt-2 float-right"
            src="../assets/imgs/logo-vlex-azul.png"
            alt="Vlex App"
            title="Ir a Vlex App"
          />
        </a>
      </div>
      <div class="col-6 text-center">
        <a href="https://mail.google.com/" target="_blank">
          <img
            class="img-fluid w-50 pt-2 float-left"
            src="../assets/imgs/gmail-logo.png"
            alt="Gmail"
            title="Ir a Gmail"
          />
        </a>
      </div>
      <div class="col-12 text-center gris">© 2020 IEE Corporativo. Todos los derechos reservados.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",

  props: {
    msg: String
  },
  data() {
    return {
      user: null,
      inicio_periodo_escolar: "",
      fin_periodo_escolar: ""
    };
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
    this.user = this.$store.state.user;
    this.setPeriodoEscolar();
  },
  methods: {
    setPeriodoEscolar() {
      var hoy = new Date();
      var ini = fin;
      var fin = "";
      var ciclo_escolar = -1;
      var ciclo_escolar_ano = hoy.getFullYear();

      if (hoy.getMonth() >= 0 && hoy.getMonth() <= 2) {
        ini = "ene";
        fin = "mar";
        ciclo_escolar = 1;
      } else if (hoy.getMonth() >= 3 && hoy.getMonth() <= 5) {
        ini = "abr";
        fin = "jun";
        ciclo_escolar = 2;
      } else if (hoy.getMonth() >= 6 && hoy.getMonth() <= 8) {
        ini = "jul";
        fin = "sept";
        ciclo_escolar = 3;
      } else if (hoy.getMonth() >= 9 && hoy.getMonth() <= 11) {
        ini = "oct";
        fin = "dic";
        ciclo_escolar = 4;
      }

      this.inicio_periodo_escolar = ini + " " + hoy.getFullYear();
      this.fin_periodo_escolar = fin + " " + hoy.getFullYear();

      this.$store.state.ciclo_escolar = ciclo_escolar;
      this.$store.state.ciclo_escolar_ano = ciclo_escolar_ano;
    }
  }
};
</script>

